import { useState, useEffect } from "react";
import { get, post } from '../../services/api';
import Select from 'react-select';
import AdminSection from "../AdminSection/AdminSection";
import "../GerenciarMetasExtra/GerenciarMetasExtra.css";
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import Swal from 'sweetalert2';

const selectStyle = {
    control: (base) => ({
        ...base,
        background: "unset",
        borderColor: "#DCDCDC",
        borderRadius: "4px"
    }),
    menuPortal: base => ({ ...base, zIndex: 9999 })
}

export default function GerenciarMetasExtra({setNotifier}){
    const [disabledGerenciamentoMetas, setDisabledGerenciamentoMetas] = useState(true);
    const [tipoMeta, setTipoMeta] = useState(null);
    const [mesFiltro, setMesFiltro] = useState(null);
    const [anoFiltro, setAnoFiltro] = useState(null);
    const [metas, setMetas] = useState([]);
    const [isSaving, setIsSaving] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [metaSelecionada, setMetaSelecionada] = useState(null);
    
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(20);

    const tipoMetaOptions = [
    { value: 'servico', label: 'Meta Serviço Extra' },
    { value: 'mercantil', label: 'Meta Mercantil' },
    ];

    const nomeMeses = [ 'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
    'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro' ];

    const formatarDecimal = (numero) => {
    if (numero === null || numero === undefined || numero === '') return numero;
    let numeroStr = String(numero).replace('.', ',');
    
    let partes = numeroStr.split(',');
    let parteInteira = partes[0];
    let parteDecimal = partes[1];
    
    parteInteira = parteInteira.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    
    return parteDecimal ? `${parteInteira},${parteDecimal}` : parteInteira;
    };
    const anoAtual = new Date().getFullYear();
    const mesAtual = new Date().getMonth() + 1;

    const optionsMes = nomeMeses.map((mes, index) => ({ label: mes, value: index + 1 }));
    const filteredMesOptions = anoFiltro?.value === anoAtual
    ? optionsMes.filter(opt => opt.value <= mesAtual)
    : optionsMes;

    const isMesAtualOuAnterior = (mes, ano) => {
    if (!mes || !ano) return false;

    const hoje = new Date();
    const atualMes = hoje.getMonth() + 1;
    const atualAno = hoje.getFullYear();

    const anterior = new Date(atualAno, hoje.getMonth() - 1, 1);
    const mesAnterior = anterior.getMonth() + 1;
    const anoAnterior = anterior.getFullYear();

    return (
        (mes === atualMes && ano === atualAno) ||
        (mes === mesAnterior && ano === anoAnterior)
    );
};
    
    const optionsAno = Array.from(
    { length: 1 + anoAtual - 2020 },
    (_, index) => ({ label: anoAtual - index, value: anoAtual - index })
    );

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = metas.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(metas.length / itemsPerPage);

    const handleOpenModal = (meta) => {
        setMetaSelecionada(meta);
        setIsModalOpen(true);
        document.body.classList.add('overflow-hidden');
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setMetaSelecionada(null);
        document.body.classList.remove('overflow-hidden');
    };

    async function salvarMetaServicoExtra(event) {
        event?.preventDefault();

        if (!metaSelecionada) return;

        setIsSaving(true);
        try {
            const adminToken = localStorage.getItem('adminToken');
            const idUsuarioAtual = localStorage.getItem('idusuario');

            const data = {
                cod_filial: metaSelecionada.cod_filial,
                mes: metaSelecionada.mes,
                ano: metaSelecionada.ano,
                meta: metaSelecionada.meta,
                meta_ideal: metaSelecionada.meta_ideal,
                meta_desafio: metaSelecionada.meta_desafio
            };

            const { response } = await post('/admin/gerenciarMetasExtra/editar-metas-servico-extra', data, adminToken,{
                headers: { 'Content-Type': 'application/json' }
            });

            if (response?.status >= 400) {
                setNotifier(false, response.data);
            } else {
                setNotifier(true, 'Meta de serviço extra atualizada com sucesso!');
                await fetchMetas(mesFiltro.value, anoFiltro.value, tipoMeta.value);
                handleCloseModal();
            }

        } catch (error) {
            console.error('Erro ao salvar meta de serviço extra:', error);
            alert('Erro ao salvar meta de serviço extra');
        } finally {
            setIsSaving(false);
        }
    }

    async function salvarMetaMercantil(event) {
        event?.preventDefault();

        if (!metaSelecionada) return;
        
        setIsSaving(true);
        try {
            const adminToken = localStorage.getItem('adminToken');
            
            const data = {
                id_filial: metaSelecionada.id_filial,
                mes: metaSelecionada.mes,
                ano: metaSelecionada.ano,
                meta_ideal: metaSelecionada.meta_ideal,
                meta_desafio: metaSelecionada.meta_desafio,
                meta_orcada: metaSelecionada.meta_orcada,
                juros_orcado: metaSelecionada.juros_orcado,
                juros_desafio: metaSelecionada.juros_desafio
            };

            const { response } = await post('/admin/gerenciarMetasExtra/editar-metas-mercantil', data, adminToken, {
                headers: { 'Content-Type': 'application/json' }
            });

            if (response?.status >= 400) {
                setNotifier(false, response.data);
            } else {
                setNotifier(true, 'Meta mercantil atualizada com sucesso!');
                await fetchMetas(mesFiltro.value, anoFiltro.value, tipoMeta.value);
                handleCloseModal();
            }

        } catch (error) {
            console.error('Erro ao salvar meta mercantil:', error);
            alert('Erro ao salvar meta mercantil');
        } finally {
            setIsSaving(false);
        }
    }

    // Função para lidar com a exclusão de metas
    async function handleExcluirMetas() {
  if (!tipoMeta?.value || !mesFiltro?.value || !anoFiltro?.value) return;

  const result = await Swal.fire({
    title: 'Confirmar exclusão',
    text: `Tem certeza que deseja excluir as metas de ${String(mesFiltro.value).padStart(2, '0')}/${anoFiltro.value} (${tipoMeta.label})? Esta ação não pode ser desfeita.`,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Sim, excluir',
    cancelButtonText: 'Cancelar',
    confirmButtonColor: '#b42318',
    cancelButtonColor: '#6b7280',
    reverseButtons: true
});
  if (!result.isConfirmed) return;

    try {
        const adminToken = localStorage.getItem('adminToken');
        const payload = {
            tipo: tipoMeta.value,
            mes: mesFiltro.value,
            ano: anoFiltro.value
        };

        const { response } = await post('/admin/gerenciarMetasExtra/zerar-metas', payload, adminToken, {
            headers: { 'Content-Type': 'application/json' }
        });

        if (response?.status >= 400) {
            setNotifier(false, response.data?.error || 'Erro ao zerar metas');
            return;
        }

        setNotifier(true, 'Metas zeradas com sucesso!');
        await fetchMetas(mesFiltro.value, anoFiltro.value, tipoMeta.value);
    } catch (error) {
        console.error('Erro ao excluir metas:', error);
        setNotifier(false, 'Erro ao excluir metas');
    }
}

    async function fetchMetas(mes, ano, tipo) {
        if (!mes || !ano || !tipo) return;

        try {
            const adminToken = localStorage.getItem('adminToken');
            const config = {
                params: { mes, ano }
            };

            const endpoint = tipo === 'servico'
                ? '/admin/gerenciarMetasExtra/metas-servico-extra'
                : '/admin/gerenciarMetasExtra/metas-mercantil';

            const response = await get(endpoint, config, adminToken);

            const metasArray = Array.isArray(response) ? response : [];
            setMetas(metasArray);
            setDisabledGerenciamentoMetas(false);
            setCurrentPage(1);
        } catch (error) {
            setMetas([]);
            setDisabledGerenciamentoMetas(true);
            setNotifier(false, 'Erro ao buscar metas. Verifique os filtros e tente novamente.');
        }
    }

    useEffect(() => {
        if (tipoMeta?.value && mesFiltro?.value && anoFiltro?.value) {
            fetchMetas(mesFiltro.value, anoFiltro.value, tipoMeta.value);
        } else {
            setMetas([]);
            setDisabledGerenciamentoMetas(true);
        }
    }, [tipoMeta, mesFiltro, anoFiltro]);

    function renderTabelaServicos() {
        return (
            <table className="adm-table metas-animais">
                <thead>
                    <tr className="adm-table-row row-metas-animais">
                        <th className='text-center'>Cod. Filial</th>
                        <th className='text-center'>Período</th>
                        <th className='text-center'>Meta</th>
                        <th className='text-center'>Meta ideal</th>
                        <th className='text-center'>Meta desafio</th>
                        <th className='text-center'>Ação</th>
                    </tr>
                </thead>
                <tbody>
                    { 
                     !Array.isArray(currentItems) || currentItems.length === 0 ? (
                        <tr>
                            <td colSpan="10" className='text-center'>
                                <WarningAmberIcon style={{ verticalAlign: 'middle', marginRight: 8, color: '#FFA000' }} />
                                Nenhuma meta encontrada para o período selecionado
                            </td>
                        </tr>
                    ) : (
                        currentItems.map((meta, index) => (
                            <tr className="adm-table-row row-metas-animais" key={index}>
                                <td className='text-center'>{meta.cod_filial}</td>
                                <td className='text-center'>{String(meta.mes).padStart(2, '0')}/{meta.ano}</td>
                                <td className='text-center'>{formatarDecimal(meta.meta)}</td>
                                <td className='text-center'>{formatarDecimal(meta.meta_ideal)}</td>
                                <td className='text-center'>{formatarDecimal(meta.meta_desafio)}</td>
                                <td className="acao-column">
                                    <button className="manage-meta-btn" onClick={() => handleOpenModal(meta)}>Editar</button>
                                </td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>
        );
    }

    function renderTabelaMercantil() {
        return (
            <table className="adm-table metas-animais">
                <thead>
                    <tr className="adm-table-row row-metas-animais">
                        <th className='text-center'>Cod. Filial</th>
                        <th className='text-center'>Período</th>
                        <th className='text-center'>Meta Ideal</th>
                        <th className='text-center'>Meta Desafio</th>
                        <th className='text-center'>Meta Orçada</th>
                        <th className='text-center'>Juros Orçado</th>
                        <th className='text-center'>Juros Desafio</th>
                        <th className='text-center'>Ação</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        !Array.isArray(currentItems) || currentItems.length === 0 ? (
                            <tr>
                                <td colSpan="10" className='text-center'>
                                    <WarningAmberIcon style={{ verticalAlign: 'middle', marginRight: 8, color: '#FFA000' }} />
                                    Nenhuma meta encontrada para o período selecionado
                                </td>
                            </tr>
                        ) : (
                            currentItems.map((meta, index) => (
                                <tr className="adm-table-row row-metas-animais" key={index}>
                                    <td className='text-center'>{meta.id_filial}</td>
                                    <td className='text-center'>{String(meta.mes).padStart(2, '0')}/{meta.ano}</td>
                                    <td className='text-center'>{formatarDecimal(meta.meta_ideal)}</td>
                                    <td className='text-center'>{formatarDecimal(meta.meta_desafio)}</td>
                                    <td className='text-center'>{formatarDecimal(meta.meta_orcada)}</td>
                                    <td className='text-center'>{formatarDecimal(meta.juros_orcado)}</td>
                                    <td className='text-center'>{formatarDecimal(meta.juros_desafio)}</td>
                                    <td className="acao-column">
                                        <button className="manage-meta-btn" onClick={() => handleOpenModal(meta)}>Editar</button>
                                    </td>
                                </tr>
                            ))
                        )
                    }
                </tbody>
            </table>
        )
    }

    return(
        <>
        <AdminSection
            etapa={1} titulo={'Selecione os filtros'}
        >
            <div className='admin-filtros-dividos p-8'>
                <div className='admin-filtros-left'>
                    <div>
                        <label style={{ whiteSpace: 'nowrap' }} htmlFor="meta">Selecione o tipo de meta</label>
                        <Select
                            name="tipoMeta"
                            className="react-select"
                            classNamePrefix="react-select"
                            options={tipoMetaOptions}
                            value={tipoMeta}
                            onChange={(selected) => {
                                setTipoMeta(selected);
                            }}
                            placeholder="Tipo de meta"
                            styles={selectStyle}
                            isSearchable={false}
                        />
                    </div>
                    <div>
                        <label style={{ whiteSpace: 'nowrap' }} htmlFor="mes">Selecione o período</label>
                        <Select
                            name="mesFiltro"
                            className="react-select"
                            classNamePrefix="react-select"
                            options={filteredMesOptions}
                            value={mesFiltro}
                            onChange={(selected) => {
                                setMesFiltro(selected);
                            }}
                            placeholder="Mês"
                            styles={selectStyle}
                            isSearchable={false}
                        />
                    </div>
                    <div>
                        <Select
                            name="anoFiltro"
                            className="react-select"
                            classNamePrefix="react-select"
                            options={optionsAno}
                            value={anoFiltro}
                            onChange={(selected) => {
                                setAnoFiltro(selected);
                            }}
                            placeholder="Ano"
                            styles={selectStyle}
                            isSearchable={false}
                        />
                    </div>                
                 {isMesAtualOuAnterior(mesFiltro?.value, anoFiltro?.value) && (
                    <div style={{ display: 'flex', alignItems: 'end' }}>
                        <button
                        type="button"
                        className="animal-refresh-btn"
                        style={{
                            backgroundColor: '#b42318',
                            color: '#fff',
                            borderRadius: '10px',
                            border: 'none',
                            padding: '0 16px',
                            height: '54px',
                            whiteSpace: 'nowrap'
                        }}
                        onClick={handleExcluirMetas}
                        >
                        Excluir dados do período
                        </button>
                    </div>
                    )}
        </div>
    </div>
            
            <div className="body">
                        {tipoMeta?.value === 'servico' && renderTabelaServicos()}
                        {tipoMeta?.value === 'mercantil' && renderTabelaMercantil()}
            </div>

            
        </AdminSection>
        
        <div className='relatorio-metas-second'>
            <div className='metas-consulta-wrapper'>
                <AdminSection etapa={2} titulo={'Gerenciar Metas'} disabled={disabledGerenciamentoMetas}>
                    <div className="body">
                        {tipoMeta?.value === 'servico' && renderTabelaServicos()}
                        {tipoMeta?.value === 'mercantil' && renderTabelaMercantil()}
                    </div>

                   {metas.length > 0 && (
                    <div className="pagination-controls">
                        <button
                            className="pagination-arrow"
                            onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                            disabled={currentPage === 1}
                        >
                            Anterior
                        </button>

                        {[...Array(totalPages)].map((_, i) => {
                            const pageNum = i + 1;
                            return (
                                <button
                                    key={pageNum}
                                    onClick={() => setCurrentPage(pageNum)}
                                    className={`pagination-number ${pageNum === currentPage ? 'active' : ''}`}
                                >
                                    {pageNum}
                                </button>
                            );
                        })}

                        <button
                            className="pagination-arrow"
                            onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                            disabled={currentPage === totalPages}
                        >
                            Próximo
                        </button>
                    </div>
                )}

                    {isModalOpen && tipoMeta?.value === 'servico' && (
                        <div className="fixed top-0 left-0 right-0 bottom-0 bg-black bg-opacity-50 flex justify-center items-center z-10 overflow-auto">
                            <div className="bg-white rounded-lg w-[420px] relative">
                                <header className="bg-red-c1 p-2 rounded-t-lg relative flex items-center justify-center">
                                    <button className="absolute top-2 right-2 text-white text-xl" onClick={handleCloseModal}>
                                        &times;
                                    </button>
                                    <p className="text-md text-white text-center">Editar Meta Serviços</p>
                                </header>

                                <div className="p-4 flex flex-col items-center">
                                    {metaSelecionada && (
                                        <>
                                            <div className="text-center mb-4">
                                                <p><strong>Filial:</strong> {metaSelecionada.cod_filial}</p>
                                                <p><strong>Período:</strong> {String(metaSelecionada.mes).padStart(2, '0')}/{metaSelecionada.ano}</p>
                                            </div>

                                            {[
                                                { key: 'meta', label: 'Meta' },
                                                { key: 'meta_ideal', label: 'Meta Ideal' },
                                                { key: 'meta_desafio', label: 'Meta Desafio' },
                                            ].map(({ key, label }) => (
                                                <div key={key} className="mb-3 w-full flex flex-col items-center">
                                                    <label className="block mb-1">{label}:</label>
                                                    <input
                                                        type="number"
                                                        className="text-center border rounded px-2 py-1 w-40"
                                                        value={metaSelecionada[key]}
                                                        onChange={(e) =>
                                                            setMetaSelecionada({ ...metaSelecionada, [key]: e.target.value })
                                                        }
                                                    />
                                                </div>
                                            ))}

                                            <div className="flex flex-wrap justify-center gap-4 mt-4">
                                                <button className="animal-cancel-btn" onClick={handleCloseModal}>Cancelar</button>
                                                <button className="animal-save-btn" onClick={salvarMetaServicoExtra}disabled={isSaving}>
                                                    {isSaving ? 'Salvando...' : 'Salvar'}
                                                </button>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}

                    {isModalOpen && tipoMeta?.value === 'mercantil' && (
                        <div className="fixed top-0 left-0 right-0 bottom-0 bg-black bg-opacity-50 flex justify-center items-center z-10 overflow-auto">
                            <div className="bg-white rounded-lg w-[420px] relative">
                                <header className="bg-red-c1 p-2 rounded-t-lg relative flex items-center justify-center">
                                    <button className="absolute top-2 right-2 text-white text-xl" onClick={handleCloseModal}>
                                        &times;
                                    </button>
                                    <p className="text-md text-white text-center">Editar Meta Mercantil</p>
                                </header>

                                <div className="p-4 flex flex-col items-center">
                                    {metaSelecionada && (
                                        <>
                                            <div className="text-center mb-4">
                                                <p><strong>Filial:</strong> {metaSelecionada.id_filial}</p>
                                                <p><strong>Período:</strong> {String(metaSelecionada.mes).padStart(2, '0')}/{metaSelecionada.ano}</p>
                                            </div>

                                            <div className="grid grid-cols-2 gap-4">
                                                {[
                                                    { key: 'meta_ideal', label: 'Meta Ideal' },
                                                    { key: 'meta_desafio', label: 'Meta Desafio' },
                                                    { key: 'meta_orcada', label: 'Meta Orçada' },
                                                    { key: 'juros_orcado', label: 'Juros Orçado' },
                                                    { key: 'juros_desafio', label: 'Juros Desafio' },
                                                ].map(({ key, label }) => (
                                                    <div key={key} className="flex flex-col items-center">
                                                        <label className="block mb-1">{label}:</label>
                                                        <input
                                                            className="text-center"
                                                            type="number"
                                                            value={metaSelecionada[key]}
                                                            onChange={(e) =>
                                                                setMetaSelecionada({ ...metaSelecionada, [key]: e.target.value })
                                                            }
                                                        />
                                                    </div>
                                                ))}
                                            </div>

                                            <div className="modal-gerencia-animal-footer flex justify-center gap-4 mt-4">
                                                <button className="animal-cancel-btn" onClick={handleCloseModal}>Cancelar</button>
                                                <button className="animal-save-btn" onClick={salvarMetaMercantil}disabled={isSaving}>
                                                    {isSaving ? 'Salvando...' : 'Salvar'}
                                                </button>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}

                </AdminSection>
            </div>
        </div>    
        </>
    )
}